export default "__VITE_ASSET__CYnCu4SN__"